import { SecodaMinimalLogo } from '@repo/common/components';
import {
	isEmoji,
	isTablerIcon,
	stringToIconEmojiSelectorValue,
} from '@repo/common/components/IconEmojiSelector/utils';
import { Icon, Text } from '@repo/foundations';
import { includes } from 'lodash-es';
import { ENTITY_NODE_HEADER_INTEGRATION_ICON_SIZE } from '../EntityNodeHeader/EntityNodeHeader.constants';
import type { EntityIconProps } from './EntityIcon.types';
import EntityTypeIcon from './EntityTypeIcon';
import type { EntityTypeIconOptions } from './EntityTypeIcon.types';
import { ENTITY_TYPE_ICON_OPTIONS } from './EntityTypeIcon.types';
import IntegrationTypeIcon from './IntegrationTypeIcon';

export function EntityIcon({
	icon,
	entityType,
	integrationType,
	size = ENTITY_NODE_HEADER_INTEGRATION_ICON_SIZE,
}: EntityIconProps) {
	if (icon) {
		const iconValue = stringToIconEmojiSelectorValue(icon);

		if (isEmoji(iconValue)) {
			return <Text style={{ fontSize: size }}>{iconValue.emoji}</Text>;
		}

		if (isTablerIcon(iconValue)) {
			return (
				<Icon
					name={iconValue.iconName}
					iconWidth={size}
					iconHeight={size}
					style={{ color: iconValue.iconColor, width: size, height: size }}
				/>
			);
		}
	}

	if (includes(ENTITY_TYPE_ICON_OPTIONS, entityType)) {
		return (
			<EntityTypeIcon
				entityType={entityType as EntityTypeIconOptions}
				size={size}
			/>
		);
	}

	if (integrationType) {
		return (
			<IntegrationTypeIcon integrationType={integrationType} size={size} />
		);
	}

	return <SecodaMinimalLogo width={size} height={size} />;
}
